
export const weirwoodOption = {
    error: {
        collectWindowErrors: true,
        // promise异常
        collectUnhandledRejections: true,
        // 静态资源加载异常
        collectResourceLoadErrors: false
    },
    perf: {
        // 性能数据PV日志会比较大，可以输入 sampleRate 进行采样，控制在 50 W左右
        sampleRate: 0.3,
        spa: true,
        history: true
    }
};